var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{staticStyle:{"paddingTop":"20px"}},[_c('avue-form-design',{ref:"avueformdesign",attrs:{"mode":2,"options":_vm.options},on:{"on-mode":_vm.handleMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }